import React from "react"
import styles from "./photo.module.scss"

const Photo = (props) => {
  // console.log('Photo props: '+ JSON.stringify(props))
  let thisPhoto = searchForPhotoFormat(props.photoName, props.object.photoFormatsS3)
  if (typeof thisPhoto === 'undefined'){
    thisPhoto = searchForPhotoFormat('original', props.object.photoFormatsS3)
  }
  let aimConfig = `?impolicy=crop-resize&h=${thisPhoto.h}&w=${thisPhoto.w}&x=${thisPhoto.x}&y=${thisPhoto.y}`
  // let photoSize = `&width=${props.photoSize.width}&height=${props.photoSize.width}`
  let photoSize = `&width=100`

  let imgURL = "https://m1.quebecormedia.com/emp/emp/" + thisPhoto.fileName + aimConfig + photoSize

  let imgSrcSet = makeSrcSet(thisPhoto.fileName, aimConfig);

  let photoCredit
  if (typeof props.object.creditLine !== "undefined") {
    if (props.object.creditLine !== null) {
      photoCredit = <div className={styles.creditPhoto}>{props.object.creditLine}</div>
    }
  }
  let photoDescription
  if (typeof props.object.description !== "undefined"){
    if (props.object.description !== null){
      photoDescription = <div className={styles.bdev}>{props.object.description}</div>
    }
  }

  let photoSizes = ""
  if (typeof props.photoSizes === "undefined"){
    photoSizes = "100vw"
  } else {
    photoSizes = props.photoSizes;
  }
  return(
    <div className={styles.inlinePhotosContainer}>
      <div className={styles.photoContainer}>
        <img alt={props.object.description} src={imgURL} srcSet={imgSrcSet} sizes={photoSizes} />
        {photoCredit}

      </div>
      {photoDescription}

    </div>
  )
}

export default Photo

function searchForPhotoFormat(nameKey, myArray){
  for (var i=0; i < myArray.length; i++) {
    if (myArray[i].photoFormatType === nameKey) {
      return myArray[i];
    }
  }
}

function makeSrcSet(thisPhoto, aim){
  const increments = 100;
  let finalString = "";
  for (let i=100; i<=3000; i+=increments){
    finalString += "https://m1.quebecormedia.com/emp/emp/" + thisPhoto + aim + `&width=${i} ${i}w, `
  }
  return finalString


}